module.exports = __webpack_public_path__ + "static/img/banner1.cb867acd.png";